import React from 'react';
import PropTypes from 'prop-types';

import { getCharByElementPosition, parseElement } from '../../../lib/exercise';
import { get } from 'lodash';
import styled from 'styled-components';

import MathContent from '../../math-content';
import ChoiceChip from '../../choice-chip';
import Question from './question';

import GridContainer from '../../layouts/components/grid-container';

const ChoiceChipContainer = styled.div``;

const FeedbackContainer = styled.div`
    margin: 0 32px;
`;

export const Label = styled.span`
    display: inline-block;
    font-weight: 600;
    margin-right: 4px;
    margin-top: 8px;
`;

const Feedback = styled.span`
    display: inline-block;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0;
    margin-top: 8px;
`;

export const Solution = styled.div`
    display: flex;
    flex-direction: column;
`;

export const CorrectChoiceChip = styled.span`
    margin-top: 8px;
`;

const SingleDragDropCorrectionContainer = styled.div`
    display: block;
`;

const getLabel = (type) => {
    switch (type) {
        case 'success':
            return 'Risposta esatta.';
        case 'error':
            return 'Risposta sbagliata.';
        case 'missing':
        default:
            return 'Risposta non data.';
    }
};

export const SingleDragDropCorrection = ({ correctAnswer, selectedAnswer, type, index, solution }) => {
    return (
        <SingleDragDropCorrectionContainer>
            <ChoiceChipContainer>
                <ChoiceChip
                    id={`${index}`}
                    key={`${index}`}
                    badgeIndex={getCharByElementPosition(index + 1)}
                    value={type === 'error' ? selectedAnswer.values[0].text : correctAnswer.values[0].text}
                    type="validated"
                    validationType={solution ? 'success' : type}
                />
            </ChoiceChipContainer>
            <FeedbackContainer>
                {!solution && <Label>{getLabel(type)}</Label>}

                {((correctAnswer && correctAnswer.feedback) || (selectedAnswer && selectedAnswer.feedback)) && (
                    <>
                        {solution && <Label>{'Feedback specifico.'}</Label>}
                        <Feedback>
                            <MathContent>{type === 'missing' ? correctAnswer.feedback : selectedAnswer.feedback}</MathContent>
                        </Feedback>
                    </>
                )}

                {type === 'error' && (
                    <Solution>
                        <Label>{'La risposta esatta è:'}</Label>
                        <CorrectChoiceChip>
                            <ChoiceChip type="validated" validationType="missing" value={correctAnswer.values[0].text} />
                        </CorrectChoiceChip>
                    </Solution>
                )}
            </FeedbackContainer>
        </SingleDragDropCorrectionContainer>
    );
};

SingleDragDropCorrection.propTypes = {
    correctAnswer: PropTypes.object,
    index: PropTypes.number,
    selectedAnswer: PropTypes.object,
    type: PropTypes.string,
    solution: PropTypes.bool,
};

export function getFeedbackTypes(answer, gapList, options) {
    return gapList.map((item) => {
        const selectedAnswer = answer && answer.find((answer) => answer.gapId === item.id);
        const selectedAnswerText = get(
            options.find((item) => item.id === get(selectedAnswer, 'optionId')),
            'values[0].text',
        );
        const selectedAnswerId = get(selectedAnswer, 'optionId');

        switch (selectedAnswerText) {
            case undefined:
                return { ...item, selectedAnswerId: null, type: 'missing' };
            case item.text:
                return { ...item, selectedAnswerId: selectedAnswerId, type: 'success' };
            default:
                return { ...item, selectedAnswerId: selectedAnswerId, type: 'error' };
        }
    });
}

const DragDropCorrection = ({ exercise, solution, answers = [] }) => {
    const answer = answers ? answers.answer : [];
    const gapList = Array.from(parseElement(exercise.question, exercise.options));
    let parsedGapList = gapList.map((item) => {
        return {
            id: item[0].replace('_', ''),
            correctAnswerId: item[1].responseId,
            char: item[1].char,
            text: item[1].text,
        };
    });

    let correctedGapList = getFeedbackTypes(answer, parsedGapList, exercise.options);

    return (
        <>
            <GridContainer paddingLeft="regular">
                {exercise.prompt && <MathContent>{exercise.prompt}</MathContent>}
                {exercise.question && <Question answers={answers.answer} exercise={exercise} solution={solution} />}
            </GridContainer>

            <GridContainer>
                {correctedGapList.map((gap, index) => {
                    const selectedAnswer = exercise.options.find((option) => option.id === gap.selectedAnswerId);
                    const correction = exercise.options.find((option) => option.id === gap.correctAnswerId);
                    return (
                        <SingleDragDropCorrection
                            key={index}
                            index={index}
                            type={gap.type}
                            correctAnswer={correction}
                            selectedAnswer={selectedAnswer}
                            solution={solution}
                        />
                    );
                })}
            </GridContainer>
        </>
    );
};

DragDropCorrection.propTypes = {
    answers: PropTypes.shape({
        exerciseId: PropTypes.number,
        answer: PropTypes.array,
    }),
    exercise: PropTypes.object,
    solution: PropTypes.bool,
};

export default DragDropCorrection;
